export const onKeysDownClick = keys => e => {
  if (e.target === e.currentTarget && keys.includes(e.key)) {
    e.preventDefault()
    e.target.click()
  }
};
export const onEnterDownClick = onKeysDownClick(['Enter'])
export const onEnterOrSpaceDownClick = onKeysDownClick(['Enter', ' '])